import axios from 'axios'
import ElementUI from 'element-ui'

axios.defaults.withCredentials = true // 允许携带cookie

// 在request拦截器中显示进度条Nprogress.start()
axios.interceptors.request.use((config) => {
  // 请求开始时显示进度条
  // NProgress.start();
  return config
})

// 返回状态判断
axios.interceptors.response.use(
  (res) => {
    // res中完成进度条Nprogress.done()
    // NProgress.done();
    if (res.status === 200 && res.data.state === 'fail') {
      if (res.data.msg) {
        setTimeout(() => {
          ElementUI.Message.error(res.data.msg)
        })
      }
    }
    if (res.status === 200 && res.data.state === 'fail' && res.data.closeSystem) {
      window.location = 'http://www.baidu.com'
    } else if (res.status === 200 && res.data.state === 'fail' && res.data.showCommonStr) {
      ElementUI.Message.error(res.data.msg)
    } else {
      return res
    }
    //closeSystem
  },
  (err) => {
    // 对响应错误做点什么
    if (err.response) {
      // 请求已发出，服务器返回状态码超出2xx范围
      const { status, config } = err.response
      if (status === 500) {
        // 可以在这里处理500错误，比如显示提示、跳转页面等
        ElementUI.Message.error(`服务器报500错误(${config.url})`)
      }
    }

    return Promise.reject(err)
  }
)

export default axios
